import Mock from 'mockjs'
import loginAPI from './login'
import articleAPI from './article'
import remoteSearchAPI from './remoteSearch'
import transactionAPI from './transaction'
import orderAPI from './order'
import sendAPI from './send'
import clearingBalanceAPI from './clearingBalance'

// Mock.setup({
//   timeout: '350-600'
// })

// 登录相关
Mock.mock(/\/login\/login/, 'post', loginAPI.loginByUsername)
Mock.mock(/\/login\/logout/, 'post', loginAPI.logout)
Mock.mock(/\/user\/info\.*/, 'get', loginAPI.getUserInfo)

// 文章相关
Mock.mock(/\/article\/list/, 'get', articleAPI.getList)
Mock.mock(/\/article\/detail/, 'get', articleAPI.getArticle)
Mock.mock(/\/article\/pv/, 'get', articleAPI.getPv)
Mock.mock(/\/article\/create/, 'post', articleAPI.createArticle)
Mock.mock(/\/article\/update/, 'post', articleAPI.updateArticle)

// 搜索相关
Mock.mock(/\/search\/user/, 'get', remoteSearchAPI.searchUser)

// 账单相关
Mock.mock(/\/transaction\/list/, 'get', transactionAPI.getList)

// 订单想着
Mock.mock(/\/order\/list/, 'get', orderAPI.getList)

// 领书相关
Mock.mock(/\/send\/class\/list/, 'get', sendAPI.getList)
Mock.mock(/\/send\/assgin\/class\/list/, 'get', sendAPI.getAssginList)
Mock.mock(/\/send\/teacher\/list/, 'get', sendAPI.getList1)
Mock.mock(/\/send\/assgin\/teacher\/list/, 'get', sendAPI.getAssginList1)
Mock.mock(/\/send\/assgin\/student\/list/, 'get', sendAPI.getAssginList2)
Mock.mock(/\/send\/assgin\/record\/list/, 'get', sendAPI.getRecordList)

// 选书进度列表
Mock.mock(/\/order\/college\/todo\/list/, 'get', orderAPI.getOrderByCollege)

// 处理结算系统内容
Mock.mock(/\/clearing\/balance\/list\/detail/, 'get', clearingBalanceAPI.getClearingBalanceList)
Mock.mock(/\/clearing\/balance\/list/, 'get', clearingBalanceAPI.getList)
Mock.mock(/\/clearing\/balance\/for\/class\/list/, 'get', clearingBalanceAPI.getClearingBalanceListForClass)
Mock.mock(/\/clearing\/balance\/for\/student\/list/, 'get', clearingBalanceAPI.getClearingBalanceListForStudent)

export default Mock



// WEBPACK FOOTER //
// ./src/mock/index.js